import { GridList, GridListTile } from '@material-ui/core';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import PropTypes from 'prop-types';

const ImageGallery = ({ images, width }) => {
  const getGridListCols = () => {
    if (isWidthUp('md', width)) {
      return 3;
    }
    return 2;
  };

  return (
    <div className="text-center">
      {images ? (
        <GridList cols={getGridListCols()}>
          {images.map((image) => (
            <GridListTile key={image && image.url ? image.url : image} cols={1}>
              {image && (image.category || image.caption) ? (
                <div className="absolute z-10 text-white bg-black w-full text-left text-xs bg-opacity-50 pl-1 bottom-0">
                  {image.category}
                  {image.caption ? `: ${image.caption}` : undefined}
                </div>
              ) : <></>}
              <img
                src={image && image.url ? image.url : image}
                alt={image && (image.caption || image.name)}
              />
            </GridListTile>
          ))}
        </GridList>
      ) : 'No photos'}
    </div>
  );
};

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    caption: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  width: PropTypes.number.isRequired,
};

export default withWidth()(ImageGallery);
